import type { Address, Hex } from "viem"
import {
  type TransactionItemBase,
  type TransactionItemUnion,
  TransactionLabel,
} from "./baseTransactionTypes"
import { EvcTransaction } from "./evcTransactionTypes"
import { PermitTransactionItem } from "./permit2TransactionTypes"
import { VaultTransactionItem } from "./vaultTransactionTypes"

export type RewardStreamsTransactionLabel =
  | TransactionLabel.ENABLE_REWARD
  | TransactionLabel.DISABLE_REWARD
  | TransactionLabel.CLAIM_REWARD

export type RewardStreamsTransaction = {
  ignoreRecentReward?: boolean
  label: RewardStreamsTransactionLabel
  rewarded: Address
  reward: Address
  transactions?: (
    | EvcTransaction
    | PermitTransactionItem
    | VaultTransactionItem
    | RewardStreamsTransactionItem
  )[]
}

export type MerklTransaction = {
  label: TransactionLabel.CLAIM_MERKL_REWARD
  address: Address
  reward: Address
  accumulated: bigint
  proof: Hex[]
}

export type UnlockREulTransaction = {
  label: TransactionLabel.UNLOCK_REUL
  account: Address
  lockTimestamp: number
}

export type RewardStreamsTransactionItem =
  TransactionItemBase<RewardStreamsTransaction>

export type MerklTransactionItem = TransactionItemBase<MerklTransaction>

export type UnlockREulTransactionItem =
  TransactionItemBase<UnlockREulTransaction>

export function isRewardStreamsTransaction(
  transaction: TransactionItemUnion,
): transaction is RewardStreamsTransactionItem {
  return (
    "label" in transaction &&
    (transaction.label === TransactionLabel.ENABLE_REWARD ||
      transaction.label === TransactionLabel.DISABLE_REWARD ||
      transaction.label === TransactionLabel.CLAIM_REWARD)
  )
}

export function isEnableRewardTransaction(
  transaction: TransactionItemUnion,
): transaction is RewardStreamsTransactionItem {
  return transaction.label === TransactionLabel.ENABLE_REWARD
}

export function isDisableRewardTransaction(
  transaction: TransactionItemUnion,
): transaction is RewardStreamsTransactionItem {
  return transaction.label === TransactionLabel.DISABLE_REWARD
}

export function isClaimRewardTransaction(
  transaction: TransactionItemUnion,
): transaction is RewardStreamsTransactionItem {
  return transaction.label === TransactionLabel.CLAIM_REWARD
}

export function isMerklTransaction(
  transaction: TransactionItemUnion,
): transaction is MerklTransactionItem {
  return transaction.label === TransactionLabel.CLAIM_MERKL_REWARD
}

export function isUnlockREulTransaction(
  transaction: TransactionItemUnion,
): transaction is UnlockREulTransactionItem {
  return transaction.label === TransactionLabel.UNLOCK_REUL
}
